<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table" v-show="id < 0">
            <template #default="{row, property}">
                <el-link type="primary" :underline="false" @click="id = row['id']" v-if="property === 'name'">
                    {{row['name']}}
                </el-link>
                <span v-else-if="property === 'isUsed'">
                    {{row['userId'] > 0 ? "是" : "否"}}
                </span>
            </template>
            <template #tools="{row}">
                <el-button type="text" icon="el-icon-delete" size="small" @click="toDel(row)">删除</el-button>
            </template>
        </RemoteTable>
        <Config :id="id" @close="close" v-if="id > -1"></Config>
    </div>
</template>
<script>
    import RemoteTable from "@/components/RemoteTable"
    import Config from "./Config.vue"

    export default {
        components: {
            RemoteTable,
            Config,
        },
        data() {
            return {
                id: -1,
                form: {
                    tools: [
                        {icon: "el-icon-plus", click: () => {this.id = 0;}}
                    ],
                    configs: [
                        {label: "名称", name: "name", type: "input", op: "contains", value: ""},
                    ]
                },
                table: {
                    urlPrefix: "/datasource",
                    columns: [
                        {label: "名称", name: "name"},
                        {label: "描述", name: "description"},
                        {label: "地址", name: "host"},
                        {label: "是否使用", name: "isUsed", width: 120},
                        {label: "创建时间", name: "createTime", sortable: true, width: 160},
                        {label: "操作", name: "tools", width: 80},
                    ],
                }
            }
        },
        methods: {
            toDel(row) {
                this.$confirm("删除数据源会导致原租户数据不可用，请谨慎操作，是否继续？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    this.$axios.get('/datasource/remove/' + row.id).then(response => {
                        if (response['code'] === 0) {
                            this.$message.success(this.$t("删除成功！"));
                            this.$refs.table.load();
                        } else {
                            this.$message.error(response['msg']);
                        }
                    })
                });
            },
            close(reload) {
                this.id = -1;
                if (reload) {
                    this.$refs.table.load();
                }
            }
        }
    }
</script>